import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import MagnetIcon from 'assets/svgr-icons/Magnet.svg'
import { memo } from 'react'
import { useMagnet } from './useMagnet'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

const MagnetButton = () => {
  const { hasGaps, applyMagnet } = useMagnet()
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)
  return (
    <ActionButton
      icon={<MagnetIcon />}
      tooltipText={translate(T.MAGNET_LABEL)}
      title={isMobile ? translate(T.MAGNET_LABEL) : undefined}
      onClick={applyMagnet}
      disabled={!hasGaps}
    />
  )
}

export default memo(MagnetButton)
